export const forgotPassword = (data) => ({
  ...data,
})

